import React from "react";
import ReactDOM from "react-dom/client";
import "./config/axios"; // Global axios interceptor (attaches Bearer token)
import App from "./App.jsx";
import "./assets/css/index.css";

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
